module.exports = __webpack_public_path__ + "static/media/slider-backgrounda-1024x531.321d642b.jpg";